import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e0788b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-cast" }
const _hoisted_2 = { class: "nge-cast-head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cast-title" }, "Meet the cells", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-cast-lead" }
const _hoisted_5 = {
  key: 0,
  class: "nge-cast-now"
}
const _hoisted_6 = { class: "nge-cast-now-name" }
const _hoisted_7 = {
  key: 0,
  class: "nge-cast-about"
}
const _hoisted_8 = {
  key: 1,
  class: "nge-cast-classes"
}
const _hoisted_9 = {
  key: 1,
  class: "nge-cast-now-row"
}
const _hoisted_10 = { class: "nge-cast-now-text" }
const _hoisted_11 = { class: "nge-cast-now-name" }
const _hoisted_12 = { class: "nge-cast-now-meta" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "nge-cast-now-count" }
const _hoisted_15 = {
  key: 2,
  class: "nge-cast-about"
}
const _hoisted_16 = {
  key: 3,
  class: "nge-cast-note"
}
const _hoisted_17 = {
  key: 4,
  class: "nge-cast-note nge-cast-note--err"
}
const _hoisted_18 = { class: "nge-cast-controls" }
const _hoisted_19 = ["title"]
const _hoisted_20 = ["title"]
const _hoisted_21 = {
  key: 5,
  class: "nge-cast-note"
}
const _hoisted_22 = { class: "nge-cast-filters" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "nge-cast-list" }
const _hoisted_25 = ["onClick", "title"]
const _hoisted_26 = { class: "nge-cast-row-text" }
const _hoisted_27 = { class: "nge-cast-row-name" }
const _hoisted_28 = ["title"]
const _hoisted_29 = {
  key: 0,
  class: "nge-cast-note nge-cast-empty"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString($setup.CAST.length) + " retinal cell types that have been identified in the Eyewire II dataset.", 1 /* TEXT */)
    ]),
    ($setup.castState.current || $setup.castState.group || $setup.castState.saved || $setup.castState.loading || $setup.castState.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          ($setup.castState.group)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString($setup.groupClass ? ($setup.groupSize === 1 ? `The ${$setup.groupClass.name.toLowerCase()}, in place` : `All ${$setup.groupSize} ${$setup.groupClass.group} together`) : `All ${$setup.groupSize} types together`), 1 /* TEXT */),
                ($setup.groupClass)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.groupClass.about), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CAST_CLASSES, (c) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: c.key,
                          class: "nge-cast-about"
                        }, [
                          _createElementVNode("b", {
                            style: _normalizeStyle({ color: c.color })
                          }, _toDisplayString(c.plural) + ".", 5 /* TEXT, STYLE */),
                          _createTextVNode(" " + _toDisplayString(c.about), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          ($setup.castState.current)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", {
                  class: "nge-cast-thumb nge-cast-thumb--big",
                  style: _normalizeStyle($setup.thumbStyle($setup.castState.current, 64))
                }, null, 4 /* STYLE */),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString($setup.castState.current.type), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ color: $setup.castClass($setup.castState.current.cls).color })
                    }, _toDisplayString($setup.castClass($setup.castState.current.cls).name), 5 /* TEXT, STYLE */),
                    ($setup.place >= 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, ", " + _toDisplayString($setup.place + 1) + " of " + _toDisplayString($setup.shown.length), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, _toDisplayString($setup.fmt($setup.castState.current.n)) + " proofread cells carry this label.", 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.castState.current)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.castClass($setup.castState.current.cls).about), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.castState.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.castState.group || !$setup.castState.current ? `Finding the cells, ${$setup.castState.found} so far...` : 'Finding the cell...'), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.castState.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.castState.error), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "nge-cast-btn",
              onClick: _cache[0] || (_cache[0] = $event => ($setup.step(-1))),
              title: $setup.castState.group ? 'The class before this one, all together' : 'The type before this one in the list'
            }, "‹ Previous", 8 /* PROPS */, _hoisted_19),
            _createElementVNode("button", {
              class: "nge-cast-btn",
              onClick: _cache[1] || (_cache[1] = $event => ($setup.step(1))),
              title: $setup.castState.group ? 'The next class, all together' : 'The next type in the list'
            }, "Next ›", 8 /* PROPS */, _hoisted_20),
            ($setup.castState.current || $setup.castState.group)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["nge-cast-btn", { 'nge-cast-on': $setup.castState.view === 'top' }]),
                    onClick: _cache[2] || (_cache[2] = $event => ($setup.setCastView('top'))),
                    title: "Look down on the retina"
                  }, "Top", 2 /* CLASS */),
                  _createElementVNode("button", {
                    class: _normalizeClass(["nge-cast-btn", { 'nge-cast-on': $setup.castState.view === 'side' }]),
                    onClick: _cache[3] || (_cache[3] = $event => ($setup.setCastView('side'))),
                    title: "Look at the retina from the side"
                  }, "Side", 2 /* CLASS */),
                  _createElementVNode("button", {
                    class: _normalizeClass(["nge-cast-btn", { 'nge-cast-on': $setup.castState.spinning }]),
                    onClick: _cache[4] || (_cache[4] = $event => ($setup.toggleSpin())),
                    title: "Turn the cell slowly. Drag the cell to stop."
                  }, _toDisplayString($setup.castState.spinning ? 'Stop' : 'Spin'), 3 /* TEXT, CLASS */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            ($setup.castState.saved)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "nge-cast-btn nge-cast-back",
                  onClick: _cache[5] || (_cache[5] = $event => ($setup.backToMyView())),
                  title: "Put back the view you had before the cast, with your layers"
                }, "Back to my view"))
              : _createCommentVNode("v-if", true)
          ]),
          ($setup.castState.current)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Drag the cell to turn it. Scroll to zoom."))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("button", {
        class: _normalizeClass(["nge-cast-chip", { 'nge-cast-chip--on': !$setup.cls }]),
        onClick: _cache[6] || (_cache[6] = $event => ($setup.cls = ''))
      }, "All " + _toDisplayString($setup.CAST.length), 3 /* TEXT, CLASS */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CAST_CLASSES, (c) => {
        return (_openBlock(), _createElementBlock("button", {
          key: c.key,
          class: _normalizeClass(["nge-cast-chip", { 'nge-cast-chip--on': $setup.cls === c.key }]),
          style: _normalizeStyle({ '--chip': c.color }),
          onClick: $event => ($setup.cls = $setup.cls === c.key ? '' : c.key)
        }, _toDisplayString(c.plural) + " " + _toDisplayString($setup.countOf(c.key)), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_23))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["nge-cast-btn nge-cast-all", { 'nge-cast-on': $setup.castState.group === $setup.groupKey }]),
      onClick: _cache[7] || (_cache[7] = $event => ($setup.showCastGroup($setup.groupKey))),
      title: "Every example cell at once, each where it sits in the retina"
    }, _toDisplayString($setup.groupLabel), 3 /* TEXT, CLASS */),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.query) = $event)),
      class: "nge-cast-search",
      type: "search",
      placeholder: "Find a type, like ON alpha",
      "aria-label": "Find a cell type"
    }, null, 512 /* NEED_PATCH */), [
      [_vModelText, $setup.query]
    ]),
    _createElementVNode("div", _hoisted_24, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.shown, (t) => {
        return (_openBlock(), _createElementBlock("button", {
          key: t.sv,
          class: _normalizeClass(["nge-cast-row", { 'nge-cast-row--on': $setup.isCurrent(t) }]),
          onClick: $event => ($setup.showCastType(t)),
          title: `Show the ${t.type} example alone in 3D`
        }, [
          _createElementVNode("span", {
            class: "nge-cast-thumb",
            style: _normalizeStyle($setup.thumbStyle(t))
          }, null, 4 /* STYLE */),
          _createElementVNode("span", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, [
              ($setup.castColors[t.sv] && $setup.castState.group)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "nge-cast-dot",
                    style: _normalizeStyle({ background: $setup.castColors[t.sv] })
                  }, null, 4 /* STYLE */))
                : _createCommentVNode("v-if", true),
              _createTextVNode(_toDisplayString(t.type), 1 /* TEXT */)
            ]),
            _createElementVNode("span", {
              class: "nge-cast-row-cls",
              style: _normalizeStyle({ color: $setup.castClass(t.cls).color })
            }, _toDisplayString($setup.castClass(t.cls).name), 5 /* TEXT, STYLE */)
          ]),
          _createElementVNode("span", {
            class: "nge-cast-row-n",
            title: `${$setup.fmt(t.n)} proofread cells carry this label`
          }, _toDisplayString($setup.fmt(t.n)), 9 /* TEXT, PROPS */, _hoisted_28)
        ], 10 /* CLASS, PROPS */, _hoisted_25))
      }), 128 /* KEYED_FRAGMENT */)),
      (!$setup.shown.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, "No type matches \"" + _toDisplayString($setup.query) + "\".", 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}